import { render, staticRenderFns } from "./NewSkeletonBox.vue?vue&type=template&id=7ef54a43&scoped=true&"
import script from "./NewSkeletonBox.vue?vue&type=script&lang=js&"
export * from "./NewSkeletonBox.vue?vue&type=script&lang=js&"
import style0 from "./NewSkeletonBox.vue?vue&type=style&index=0&id=7ef54a43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef54a43",
  null
  
)

export default component.exports